import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

export const initPaymentWallet = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IInitTransactionWallet } = await request.post(
        '/api/v1/payment/init/?os_type=android&app_version=1.892.9',
        [
            {
                id: ctx.queryKey[1],
                type: 'mbr',
                amount: ctx.queryKey[3] ? Number(ctx.queryKey[3]) : 0,
                cashin_type: 'hwt',
                paid_obj_id: 0,
            },
        ]
    )
    return data
}

export const paymentTransactions = async (
    payload: IPaymentTransactionsPayload
) => {
    const { data } = await request.post('/api/v1/payment/transactions/', [
        {
            amount: payload.amount,
            ctx_id: payload.ctx_id,
            ctx_type: 'mbr',
            destination: 'hwt',
            gateway: 9,
            is_group_pay: false,
            payer_name: '',
            receiver: payload.ctx_id,
            receiver_name: '',
            source: 'gtw',
            state: '',
            state_time: '',
            transaction_code: '',
        },
    ])
    return data
}

export const postGatewayPaymentChargeWallet = async (payload: any) => {
    const { data }: { data: IinitGatewayPayment } = await request.post(
        '/api/v2/payment/gateways/gateway-payment/',
        payload
    )
    return data
}
